import React, { useState, useEffect } from "react";
import GUIset_DoubleCombo from "./gui/GUIset_DoubleCombo";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const Sorting = () => {
	useEffect(() => {
		document.title = "Non-Repeating Character";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("5,7,2,6,3,9,8,4,0,1");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result
	//-------------------------------------------
	const [selected1, setSelected1] = useState({
		value: 0,
		label: "Selection Sort",
	});
	const selecter_option = [
		{ value: -1, label: "Default JS Sort" },
		{ value: 0, label: "Selection Sort" },
		{ value: 1, label: "Bubble Sort" },
		{ value: 2, label: "Insertion Sort" },
		{ value: 3, label: "Merge Sort" },
		{ value: 4, label: "Quick Sort" },
	];
	function selection_handle(e) {
		setSelected1(e);
		// console.log("" + e.label);
		if (e.value == 0) {
			selector2_on(option_selection);
			// hideSubComboChange(false);
			// setSelecter_option2(option_selection);
			// setSelected2(option_selection[0]);
		} else if (e.value == 1) {
			selector2_on(option_bubble);
			// hideSubComboChange(false);
			// setSelecter_option2(option_bubble);
			// setSelected2(option_bubble[0]);
			// console.log("" + selected2.label);
		} else if (e.value == 2) {
			selector2_on(option_insertion);
			// hideSubComboChange(false);
			// setSelecter_option2(option_insertion);
			// setSelected2(option_insertion[0]);
		} else if (e.value == 4) {
			selector2_on(option_quick);
			// hideSubComboChange(false);
			// setSelecter_option2(option_quick);
			// setSelected2(option_quick[0]);
		} else {
			hideSubComboChange(true);
		}
	}
	function selector2_on(select_options) {
		hideSubComboChange(false);
		setSelecter_option2(select_options);
		setSelected2(select_options[0]);
	}

	//-------------------------------------------
	const [selected2, setSelected2] = useState({
		value: 0,
		label: "by Minimum",
	});
	const [selecter_option2, setSelecter_option2] = useState([
		{ value: 0, label: "by Minimum" },
		{ value: 1, label: "by Maximum" },
		{ value: 2, label: "Two-way" },
		{ value: 10, label: "by Minimum + Early Termination" },
		{ value: 11, label: "by Maximum + Early Termination" },
		{ value: 12, label: "Two-way + Early Termination" },
	]);
	function selection_handle2(e) {
		setSelected2(e);
	}
	//-------
	const option_selection = [
		{ value: 0, label: "by Minimum" },
		{ value: 1, label: "by Maximum" },
		{ value: 2, label: "Two-way" },
		{ value: 10, label: "by Minimum + Early Termination" },
		{ value: 11, label: "by Maximum + Early Termination" },
		{ value: 12, label: "Two-way + Early Termination" },
	];
	const option_bubble = [
		{ value: 0, label: "Float Up" },
		{ value: 1, label: "Float Down" },
		{ value: 2, label: "Two-way Float" },
		{ value: 10, label: "Float Up + Early Termination" },
		{ value: 11, label: "Float Down + Early Termination" },
		{ value: 12, label: "Two-way Float + Early Termination" },
	];
	const option_insertion = [
		{ value: 0, label: "From Left" },
		{ value: 1, label: "From Right" },
	];
	const option_quick = [
		{ value: 0, label: "Left Pivot, Swap" },
		{ value: 1, label: "Right Pivot, Swap" },
		{ value: 10, label: "Left Pivot, Swap + Early Termination" },
		{ value: 11, label: "Right Pivot, Swap + Early Termination" },
	];
	//-------------------------------------------
	const [hideSubCombo, hideSubComboChange] = useState(false);
	//-------------------------------------------

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			process();
			//--------------------------
			BuildResult();
			arr = [];
			arr_result = [];
		}
	};

	var input_arr = [];
	var arr = [];
	var n = arr.length;
	var txt_time = "";
	var txt_result = "";
	var arr_merge_allset = []; //for divide and conquert or tree like result
	var arr_result = []; //[][]
	// var redo_time = 1;
	var redo_time = 100000;
	var redo_i = 0;
	var iteration = 0;

	function process() {
		input_arr = T.str_toListInt(guiTxt1);
		n = input_arr.length;
		arr_merge_allset = [];
		// arr_result = [];
		var m = selected1.value;
		var m2 = selected2.value;
		//------
		var r = 1;
		if (n <= 30) {
			r = redo_time;
		} else if (n <= 100) {
			r = Math.max(1, redo_time / 10);
		}
		Timer.start();
		for (redo_i = 0; redo_i < r; redo_i++) {
			arr = T.arr_clone(input_arr);
			if (m == 0) doSort_selection(m2);
			else if (m == 1) doSort_bubble(m2);
			else if (m == 2) doSort_insertion(m2);
			else if (m == 3) doSort_merge();
			else if (m == 4) doSort_quick(m2);
			else doSort_default(m2);
		}
		// txt_time = Timer.stop_print();
		txt_time = "n = " + n + "\n";
		if (redo_i > 1) {
			txt_time += Timer.stop_print() + ` (${redo_time} redo times)`;
		} else {
			txt_time += Timer.stop_print() + ` (1 time)`;
		}
		if (m == 3) sort_merge_print();
	}

	//Common ==================

	// utility function
	function printArray(arr, n) {
		let i;
		for (i = 0; i < n; i++) document.write(arr[i] + " ");
		document.write("<br>");
	}

	function swap(arr, xp, yp) {
		if (xp != yp) {
			var temp = arr[xp];
			arr[xp] = arr[yp];
			arr[yp] = temp;
		}
	}

	//Default Sort ======================================================
	function doSort_default() {
		iteration = 1;
		if (redo_i == 0) txt_result += "0 : " + arr;
		arr.sort();
		if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
	}

	//Selection Sort ======================================================
	function doSort_selection(method) {
		iteration = 1;
		var n = arr.length;
		var i, j, min_idx, max_idx;
		var early_terminate = method >= 10 ? true : false;
		// txt_result += "Iteration : Array\n";
		if (redo_i == 0) txt_result += "0 : " + arr;
		var startpoint = 0;
		var endpoint = n - 1;
		if (method % 10 == 0) {
			//By Min
			for (i = startpoint; i < endpoint; i++) {
				min_idx = i;
				var end = true;
				for (j = i + 1; j <= n; j++) {
					if (arr[j] < arr[min_idx]) min_idx = j;
					if (arr[j] < arr[j - 1]) end = false;
				}
				if (early_terminate && end) break;
				swap(arr, min_idx, i);
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		} else if (method % 10 == 1) {
			//By Max
			for (i = endpoint; i > startpoint; i--) {
				max_idx = i;
				var end = true;
				for (j = 0; j <= i; j++) {
					if (arr[j] > arr[max_idx]) max_idx = j;
					if (arr[j] < arr[j - 1]) end = false;
				}
				if (early_terminate && end) break;
				swap(arr, max_idx, i);
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		} else {
			//MinMax
			for (i = startpoint; i < endpoint; i++) {
				min_idx = i;
				max_idx = i;
				var end = true;
				for (j = i + 1; j <= endpoint; j++) {
					if (arr[j] < arr[min_idx]) min_idx = j;
					if (arr[j] > arr[max_idx]) max_idx = j;
					if (arr[j] < arr[j - 1]) end = false;
				}
				if (early_terminate && end) break;
				if (min_idx == endpoint && max_idx == i) {
					// console.log("R1");
					swap(arr, i, min_idx);
				} else if (max_idx == i) {
					// console.log("R2");
					swap(arr, i, min_idx);
					swap(arr, endpoint, min_idx);
				} else {
					// console.log("R0");
					swap(arr, min_idx, i);
					swap(arr, max_idx, endpoint);
				}
				endpoint--;
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		}
	}

	//Bulbble Sort ======================================================

	function doSort_bubble(method) {
		iteration = 1;
		var n = arr.length;
		if (redo_i == 0) txt_result += "0 : " + arr;
		var early_terminate = method >= 10 ? true : false;
		var startpoint = 0;
		var endpoint = n - 1;
		if (method % 10 == 0) {
			for (var i = endpoint; i > startpoint; i--) {
				var end = true;
				for (var j = 0; j < i; j++) {
					if (arr[j] > arr[j + 1]) {
						swap(arr, j, j + 1);
						end = false;
					}
				}
				if (early_terminate && end) break;
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		} else if (method % 10 == 1) {
			for (i = startpoint; i < endpoint; i++) {
				var end = true;
				for (var j = endpoint - 1; j >= i; j--) {
					if (arr[j] > arr[j + 1]) {
						swap(arr, j, j + 1);
						end = false;
					}
				}
				if (early_terminate && end) break;
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		} else {
			//MaxMin
			while (true) {
				if (startpoint == endpoint) {
					break;
				}
				if (iteration % 2 == 1) {
					//max
					var end = true;
					for (var j = startpoint; j < endpoint; j++) {
						if (arr[j] > arr[j + 1]) {
							swap(arr, j, j + 1);
							end = false;
						}
					}
					if (early_terminate && end) break;
					if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
					iteration++;
					endpoint--;
				} else {
					//min
					var end = true;
					for (var j = endpoint - 1; j >= startpoint; j--) {
						if (arr[j] > arr[j + 1]) {
							swap(arr, j, j + 1);
							end = false;
						}
					}
					if (early_terminate && end) break;
					if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
					iteration++;
					startpoint++;
				}
			}
		}
	}

	//Insertion Sort ===========================

	function doSort_insertion(method) {
		iteration = 1;
		var n = arr.length;
		if (redo_i == 0) txt_result += "0 : " + arr;
		let i, x, v;
		if (method == 0) {
			for (i = 1; i < n; i++) {
				v = arr[i];
				x = i; //target index
				while (v < arr[x - 1] && x > 0) {
					arr[x] = arr[x - 1];
					x--;
				}
				arr[x] = v;
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		} else {
			for (i = n - 2; i >= 0; i--) {
				v = arr[i];
				x = i; //target index
				while (v > arr[x + 1] && x + 1 < n) {
					arr[x] = arr[x + 1];
					x++;
				}
				arr[x] = v;
				if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr;
				iteration++;
			}
		}
	}

	//Merge Sort ===========================
	function doSort_merge() {
		// if (redo_i == 0) txt_result += "0 : " + arr;
		sort_merge_Divide(arr, 0, n - 1);
		// if (redo_i == 0) txt_result += "\n" + "final : " + arr;
	}

	function sort_merge_print() {
		// // Now we have merging info, like --------
		// // 5,7,2,6,3,9,8,4,0,1
		// // 5,7,    3,6,   8,9,    0,1
		// // 2,5,7,   4,8,9
		// // 2,3,5,6,7,0,1,4,8,9
		// // 0,1,2,3,4,5,6,7,8,9
		// // we want to make a list of complete array
		//print result ------------
		txt_result += "0 : " + input_arr;
		var arr_final = T.arr_splitToSubarray(input_arr); //[[1],[2],[3],[4],[5]]
		// console.log("XXXX " + arr_final.join(" _ "));
		for (var m = 0; m < arr_merge_allset.length; m++) {
			var arr_merge = arr_merge_allset[m];
			if (arr_merge != null) {
				iteration++;
				//arr_final + arr_mergeset >> new arr_output --------------------------
				var arr_output = [];
				var i1 = 0;
				var i2 = 0;
				// txt_result += "\n\n >> " + arr_merge.join(" _ "); //For debug
				console.log(arr_final.join("_") + " >> " + arr_merge.join("_"));
				// console.log(arr_final.join(" _ "));
				// console.log(">> " + arr_merge.join(" _ "));
				// console.log(arr_final.length + " LL " + arr_mergeset.length);
				while (true) {
					if (i1 >= arr_final.length) {
						//end of array
						break;
					} else if (i2 >= arr_merge.length) {
						//no more merge
						for (var a = i1; a < arr_final.length; a++) {
							arr_output.push(arr_final[a]);
						}
						break;
					} else {
						var a1 = arr_final[i1];
						var a2 = arr_merge[i2];
						// console.log(a1 + " VS " + a2);
						if (T.arr_subsetCheck(a2, a1)) {
							// console.log("AA02");
							arr_output.push(a2);
							i2++;
							while (true) {
								//remove all duplicate
								i1++;
								if (
									i1 >= arr_final.length ||
									!T.arr_subsetCheck(a2, arr_final[i1])
								) {
									i1--; //will ++ at the end
									break;
								}
							}
						} else {
							// console.log("AA03");
							arr_output.push(a1);
						}
					}
					i1++;
					// console.log("-     " + arr_output.join(" _ "));//for debug
				}
				txt_result += "\n" + iteration + " : " + arr_output.join("_"); //see problem
				// console.log("= " + arr_output.join(" _ "));
				arr_final = arr_output;
			}
		}
	}

	function sort_merge_Divide(arr0, l, r) {
		// console.log("D" + arr0 + "_" + l + "_" +r);
		if (l >= r) {
			return;
		}
		var m = l + parseInt((r - l) / 2);
		// console.log("D " + l + "-" + m + " AND " + (m + 1) + "-" + r);
		sort_merge_Divide(arr0, l, m);
		sort_merge_Divide(arr0, m + 1, r);
		sort_merge_Conquer(arr0, l, m, r);
	}

	function sort_merge_Conquer(arr0, l, m, r) {
		var arr_L = [...arr0.slice(l, m + 1)];
		var arr_R = [...arr0.slice(m + 1, r + 1)];
		var arr_M = []; //built by arr_L and arr_R
		// console.log(l + "_" + m + "_" + r);
		// console.log(arr + " >> " + arr_L + " ++ " + arr_R);
		// console.log(arr_L +  " ++ " + arr_R);
		//
		while (arr_L.length > 0 || arr_R.length > 0) {
			if (arr_L.length == 0) {
				arr_M.push(...arr_R);
				break;
			}
			if (arr_R.length == 0) {
				arr_M.push(...arr_L);
				break;
			}
			if (arr_L[0] <= arr_R[0]) {
				arr_M.push(arr_L[0]);
				arr_L.shift();
			} else {
				arr_M.push(arr_R[0]);
				arr_R.shift();
			}
		}
		for (var i = l; i <= r; i++) {
			arr0[i] = arr_M[i - l];
		}
		//--------------
		if (redo_i == 0) {
			// console.log(" >> " + arr_M + " == " + arr);
			// console.log(l + "-" + r + " >> " + arr_M);
			var mn = arr_M.length;
			if (mn > 1) {
				if (arr_merge_allset[mn] == null) {
					arr_merge_allset[mn] = [];
				}
				arr_merge_allset[mn].push(arr_M);
			}
		}
	}

	//OLD VER
	// function sort_merge_Conquer(arr, l, m, r) {
	// 	var n_L = m - l + 1;
	// 	var n_R = r - m;
	// 	var arr_L = [...arr.slice(l, m  + 1)];
	// 	var arr_R = [...arr.slice(m + 1, r + 1)];
	// 	console.log(n_L +  " xx " + n_R);
	// 	console.log(arr_L +  " ++ " + arr_R);
	// 	// Index
	// 	var i_L = 0;
	// 	var i_R = 0;
	// 	var i_M = l;
	// 	while (i_L < n_L && i_R < n_R) {
	// 		if (arr_L[i_L] <= arr_R[i_R]) {
	// 			arr[i_M] = arr_L[i_L];
	// 			i_L++;
	// 		} else {
	// 			arr[i_M] = arr_R[i_R];
	// 			i_R++;
	// 		}
	// 		i_M++;
	// 	}
	// 	//remaining elements
	// 	while (i_L < n_L) {
	// 		arr[i_M] = arr_L[i_L];
	// 		i_L++;
	// 		i_M++;
	// 	}
	// 	while (i_R < n_R) {
	// 		arr[i_M] = arr_R[i_R];
	// 		i_R++;
	// 		i_M++;
	// 	}
	// }

	//Quick Sort ===========================
	var quicksort_stage = 0;
	var quicksort_early = false;
	var quicksort_swapfound = false;
	var quicksort_terminate = false;

	function doSort_quick(method) {
		if (method >= 10) quicksort_early = true;
		quicksort_terminate = false;
		quicksort_stage = 0;
		var n = arr.length;
		if (redo_i == 0) txt_result += "0 : " + arr;
		sort_quick_Conquer(arr, 0, n - 1, method);
		// if (redo_i == 0) console.log("Depth " + quicksort_level_found);
		// if (redo_i == 0) txt_result += "\n" + iteration + " : " + arr + "\n";
	}

	function sort_quick_Conquer(arr0, l, r, method) {
		if (quicksort_early && quicksort_terminate) {
			return;
		}
		if (l < r) {
			if (quicksort_early) quicksort_swapfound = false;
			var i_pivot = sort_quick_Divide(arr0, l, r, method);
			if (quicksort_early && !quicksort_swapfound) {
				// if (redo_i == 0) console.log("Try Early" + arr0);
				if (T.arr_isSorted(arr0)) {
					if (redo_i == 0) txt_result += " >> Early Terminated";
					quicksort_terminate = true;
					return;
				}
			}
			// else if (redo_i == 0) txt_result += " >> Pivot " + quicksort_pivot;
			// }
			// console.log("XXX " + arr0);
			if (redo_i == 0) {
				quicksort_stage++;
				txt_result += "\n" + quicksort_stage + " : " + arr0;
			}
			sort_quick_Conquer(arr0, l, i_pivot - 1, method);
			sort_quick_Conquer(arr0, i_pivot + 1, r, method);
		}
	}

	//partition
	function sort_quick_Divide(arr0, l, r, method) {
		if (method % 10 == 0) {
			let pivot = arr0[r];
			// if (redo_i == 0) txt_result += " >> pivot " + r + " (" + pivot + "), range " + l + "-" + r + "";
			// if (redo_i == 0) txt_result += ` >> pivot ${pivot}, (${r}), range ${l}-${r}`;
			if (redo_i == 0) txt_result += ` >> pivot ${pivot},  #${r} in ${l}-${r}`;
			// quicksort_pivot = pivot;
			let i = l - 1;
			for (let j = l; j < r; j++) {
				if (arr0[j] < pivot) {
					i++;
					swap(arr0, i, j);
					// console.log("XXX " + i + "_" + j);
					if (i != j) quicksort_swapfound = true;
				}
			}
			swap(arr0, i + 1, r);
			// console.log("YYY " + i + "+1 _" + r);
			if (i + 1 != r) quicksort_swapfound = true;
			return i + 1;
		} 
		else {
			let pivot = arr0[l];
			// if (redo_i == 0) txt_result += " >> pivot " + pivot + ", range " + l + "-" + r + "";
			// if (redo_i == 0) txt_result += ` >> pivot ${l} (${pivot}), range ${l}-${r}`;
			if (redo_i == 0) txt_result += ` >> pivot ${pivot},  #${l} in ${l}-${r}`;
			var i = l;
            var j = r;
            while (i < j) {
                // move right to avoid pivot element 
                i += 1;
                // scan right: find elements greater than pivot 
                while (i <= r && arr0[i] < pivot) {
                    i += 1;
                }
                // scan left: find elements smaller than pivot
                while (j >= l && arr0[j] > pivot) {
                    j -= 1;
                }
                if (i <= r && i < j) {
                    // swap around pivot  
                    swap(arr0, i, j);
					if (i != j) quicksort_swapfound = true;
                }
            }
            // put pivot in correct place
            swap(arr0, l, j);
			if (l != j) quicksort_swapfound = true;
			return j;
		}
	}

	//-------------------------

	function BuildResult() {
		var txt = txt_time + "\n\n";
		// txt_result += T.matrix_print(arr_result);
		partResultChange(
			Template.simple3size("key1", "Result", txt, txt_result, 22, 20, 22)
		);
	}

	//--------------------------------------------------------

	return (
		<GUIset_DoubleCombo
			title={"Sorting Algorithms"}
			// desc={"Compare various algorithm for sorting"}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Array"}
			label2={"Algorithm"}
			isNumOnly={false}
			txtButton={"Sort"}
			selecter_option={selecter_option}
			selectedOption={selected1}
			setSelectedOption={selection_handle}
			width2={150}
			paddingR2={0}
			paddingR3={0}
			// centerDesc={true}
			//
			label3={""}
			width3={150}
			selecter_option2={selecter_option2}
			selectedOption2={selected2}
			setSelectedOption2={selection_handle2}
			hide2={false}
			hide3={hideSubCombo}
		/>
	);
};

export default Sorting;
